module.exports = __webpack_public_path__ + "static/media/linkedinGray.e73a6d6c.svg";